{
  "level": "field3",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:field3",
    "objects": "AREAS.E3:field3.e3",
    "mesh": "TREES.E3:field3.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2799.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4370.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: field3",
      "entity_class": "CSlidingDoor",
      "piece_name": "field3",
      "offset": 437,
      "centroid": [
        1120.0,
        1600.0,
        135.29410934448242
      ],
      "bbox_min": [
        1120.0,
        1570.0,
        90.58820343017578
      ],
      "bbox_max": [
        1120.0,
        1630.0,
        180.0
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 60.0,
        "height_z": 89.41179656982422,
        "door_width": 60.0,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          1120.0,
          1570.0,
          180.0
        ],
        [
          1120.0,
          1570.0,
          180.0
        ],
        [
          1120.0,
          1570.0,
          90.5882339477539
        ],
        [
          1120.0,
          1570.0,
          90.5882339477539
        ],
        [
          1120.0,
          1630.0,
          180.0
        ],
        [
          1120.0,
          1630.0,
          180.0
        ],
        [
          1120.0,
          1630.0,
          90.58820343017578
        ],
        [
          1120.0,
          1630.0,
          90.58820343017578
        ]
      ],
      "plane_distance": -1120.0
    }
  ],
  "tutorial_messages": []
}